export const phoneReg = /^1[3456789]\d{9}$/
export const passwordReg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?![?~!,.#&@$%()|{}"<>'+*\-:;^_`]+$)[?~!,.#&@$%()|{}"<>'+*\-:;^_`0-9A-Za-z]{8,20}$/
export const emailRegexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // 邮箱正则
export const intRegexp = /^[1-9]\d*$/ // 正整数(不包含0)
export const int0Regexp = /^([1-9]\d*|[0]{1,1})$/ // 0+正整数
export const urlRegexp = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
export const telRegexp = /^([0-9]{3,4}-)?[0-9]{7,8}$/ // 固定电话正则
export const priceRegexp = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/ // 金额验证(小数点后保留两位小数)
export const postcodeRegexp = /^\d{6}$/ // 邮编正则
export const creditCodeRegexp = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/ // 统一社会信用代码正则

/**
 * el-form 判断联系电话(手机号或者固话)
 */
export function validateTelOrPhone (rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入联系电话'))
  }
  if (!(telRegexp.test(value) || phoneReg.test(value))) {
    return callback(new Error('联系电话格式不正确(如果是固定电话，则以 - 分隔)'))
  }
  callback()
}

/**
 * el-form 判断手机号
 */
export function validatePhone (rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入手机号码'))
  }
  if (!phoneReg.test(value)) {
    return callback(new Error('手机号码格式不正确'))
  }
  callback()
}

/**
 * el-form 判断邮编
 */
export function validatePostCode (rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入邮政编码'))
  }
  if (!postcodeRegexp.test(value)) {
    return callback(new Error('邮政编码格式不正确'))
  }
  callback()
}

/**
 * el-form 判断邮箱
 */
export function validateEmail (rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入邮箱'))
  }
  if (!emailRegexp.test(value)) {
    return callback(new Error('邮箱格式不正确'))
  }
  callback()
}

/**
 * el-form 判断密码
 */
export function validatePassword (rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入密码'))
  }
  if (value.length < 8 || value.length > 20) {
    return callback(new Error('密码长度必须在8-20位之间'))
  }
  if (!passwordReg.test(value)) {
    return callback(new Error('密码必须包含字母，数字，符号中至少两种(不含空格)'))
  }
  callback()
}

/**
 * el-form 判断统一社会信用代码
 */
export function validateCreditCode (rule, value, callback) {
  if (!value) {
    return callback(new Error('请输入统一社会信用代码'))
  }
  if (value.length !== 18) {
    return callback(new Error('统一社会信用代码的长度必须为18位'))
  }
  callback()
}

/**
 * 判断是否为空
 */
export function validatenull (val) {
  if (typeof val === 'boolean') {
    return false
  }
  if (typeof val === 'number') {
    return false
  }
  if (val instanceof Array) {
    if (val.length === 0) return true
  } else if (val instanceof Object) {
    if (JSON.stringify(val) === '{}') return true
  } else {
    if (val === 'null' || val == null || val === 'undefined' || val === undefined || val === '') return true
    return false
  }
  return false
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 判断身份证号码
 */
export function judgeIdCard (code) {
  let list = []
  let result = true
  let msg = ''
  var city = {
    11: '北京',
    12: '天津',
    13: '河北',
    14: '山西',
    15: '内蒙古',
    21: '辽宁',
    22: '吉林',
    23: '黑龙江',
    31: '上海',
    32: '江苏',
    33: '浙江',
    34: '安徽',
    35: '福建',
    36: '江西',
    37: '山东',
    41: '河南',
    42: '湖北',
    43: '湖南',
    44: '广东',
    45: '广西',
    46: '海南',
    50: '重庆',
    51: '四川',
    52: '贵州',
    53: '云南',
    54: '西藏',
    61: '陕西',
    62: '甘肃',
    63: '青海',
    64: '宁夏',
    65: '新疆',
    71: '台湾',
    81: '香港',
    82: '澳门',
    91: '国外'
  }
  if (!validatenull(code)) {
    if (code.length === 18) {
      if (!code || !/(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)) {
        msg = '证件号码格式错误'
      } else if (!city[code.substr(0, 2)]) {
        msg = '地址编码错误'
      } else {
        // 18位身份证需要验证最后一位校验位
        code = code.split('')
        // ∑(ai×Wi)(mod 11)
        // 加权因子
        var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        // 校验位
        var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2, 'x']
        var sum = 0
        var ai = 0
        var wi = 0
        for (var i = 0; i < 17; i++) {
          ai = code[i]
          wi = factor[i]
          sum += ai * wi
        }
        if (parity[sum % 11] !== code[17]) {
          msg = '证件号码校验位错误'
        } else {
          result = false
        }
      }
    } else {
      msg = '证件号码长度不为18位'
    }
  } else {
    msg = '证件号码不能为空'
  }
  list.push(result)
  list.push(msg)
  return list
}

/**
 * el-form判断身份证号码
 */
export function validateIdCard (rule, value, callback) {
  if (!value) {
    return callback(new Error('请填写身份证号码'))
  }
  let result = judgeIdCard(value)
  if (result[0] === true) {
    return callback(new Error(result[1]))
  }
  callback()
}
